import { convertFloatToBR } from 'utils';

import { Container } from './AreaInfo.style';

import type { AreaInfoProps } from './AreaInfo.type';

export const AreaInfo = ({
    area,
    className,
    unitType = 'hectares',
    loading = false,
}: AreaInfoProps) => {
    return (
        <Container className={className || 'area-indicator'}>
            {loading
                ? 'Carregando...'
                : `Área: ${convertFloatToBR(area, 2)} ${
                      unitType === 'hectares' ? 'ha' : 'm²'
                  }`}
        </Container>
    );
};
